var map = {
	"./project-1/image-0.webp": 6859,
	"./project-1/image-1.jpg": 7045,
	"./project-1/image-2.jpg": 3004,
	"./project-1/image-3.jpg": 1124,
	"./project-1/image-4.jpg": 763,
	"./project-1/image-5.jpg": 4662,
	"./project-1/image-6.jpg": 6921,
	"./project-1/image-7.jpg": 7481,
	"./project-2/image-0.webp": 786,
	"./project-2/image-1.jpg": 4079,
	"./project-2/image-2.jpg": 8356,
	"./project-2/image-3.jpg": 9924,
	"./project-3/image-0.webp": 3540,
	"./project-3/image-1.jpg": 8967,
	"./project-3/image-2.jpg": 5636,
	"./project-3/image-3.jpg": 9508,
	"./project-3/image-4.jpg": 3642,
	"./project-4/image-0.webp": 6815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1032;